import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { DeliveryNote } from '../../models/order/delivery-note';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/delivery-note';

  public getDeliveryNotes(): Observable<ApiResponse<DeliveryNote[]>> {
    return this.httpClient.get<ApiResponse<DeliveryNote[]>>(`${this.baseUrl}/all`);
  }

  public getDeliveryNote(id: string): Observable<ApiResponse<DeliveryNote>> {
    return this.httpClient.get<ApiResponse<DeliveryNote>>(`${this.baseUrl}/${id}`);
  }

  public getDeliveryNotesByIds(ids: string[]): Observable<ApiResponse<DeliveryNote[]>> {
    return this.httpClient.post<ApiResponse<DeliveryNote[]>>(`${this.baseUrl}/batch/ids`, ids);
  }
}
